// Footer.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './footer.css'; // Assuming kebab-case: footer.css
import { showJoke } from './showjoke'; // Assuming relative path
import useLocale from '../hooks/useLocale'; // *** 1. Import useLocale ***

function Footer() {
    // *** Get 't' function from useLocale ***
    const { t } = useLocale();
    const [currentJoke, setCurrentJoke] = useState('');
    const [animationState, setAnimationState] = useState('idle');

    // handleFoolishnessClick remains the same
    const handleFoolishnessClick = (e) => {
      e.preventDefault();
      if (animationState === 'idle') {
          const randomJoke = showJoke();
          setCurrentJoke(randomJoke);
          setTimeout(() => {
              setAnimationState('appearing');
          }, 10);
      }
    };

    // useEffect for animation remains the same
    useEffect(() => {
        let timer;
        if (animationState === 'appearing') {
             timer = setTimeout(() => { setAnimationState('visible'); }, 1500);
        } else if (animationState === 'visible') {
             timer = setTimeout(() => { setAnimationState('disappearing'); }, 7000);
        } else if (animationState === 'disappearing') {
             timer = setTimeout(() => { setAnimationState('idle'); }, 1500);
        }
        return () => clearTimeout(timer);
    }, [animationState]);

    return (
      <footer className="app-footer">
        <div className="footer-links">
            {/* *** Use t() with standardized keys *** */}
            <Link to="/tou" className="app-link">{t('nav_terms', "Terms of Use")}</Link>{'| '}
            <Link to="/pp" className="app-link">{t('nav_privacy', "Privacy Policy")}</Link>{'| '}
            <button
                type="button"
                onClick={handleFoolishnessClick}
                className="foolishness-link link-style-button" // Keep specific classes if needed for button styling
            >
                {/* *** Use t() with standardized key *** */}
                {t('footer_extras', "Extras")} {/* Changed key and default text */}
            </button>
        </div>
        {/* Conditionally render the joke container */}
        {animationState !== 'idle' && (
            <div className={`joke-container ${animationState}`}>
                {/* Joke content itself isn't localized here, comes from showJoke() */}
                {currentJoke}
            </div>
        )}
      </footer>
    );
}

export default Footer;